import { date, relation, lazy, writer, children } from '@nozbe/watermelondb/decorators';
import { uuid } from '../../oscar-pos-core/constants';
import { CART_ITEMS, CART_SCHEMA } from '../schema';
import { Model, Q } from '@nozbe/watermelondb';

export default class Cart extends Model {
    static table = CART_SCHEMA

    static associations = {
        business: { type: 'belongs_to', key: 'business_id' },
        customer: { type: 'belongs_to', key: 'customer_id' },
        cart_items: { type: 'has_many', foreignKey: 'cart_id' },
    }

    @date('created_at') created_at;

    @relation('business', 'business_id') business;
    @relation('customer', 'customer_id') customer;

    @children('cart_items') cart_items;

    @lazy getCartItemByIDs = (variant_id, product_id) => this.cart_items.extend(Q.and(Q.where('product_id', product_id), Q.where('variant_id', variant_id)));


    @writer async emptyCard() {
        await this.cart_items.destroyAllPermanently()
    }


    @writer async createCartItem(details) {
        return await this.collections.get(CART_ITEMS).create(item => {
            item.cart.set(this)
            item.stock.set(details.modal)
            item._raw.id = uuid()
            item.product_id = details.product_id
            item.product_name = details.product_name
            item.quantity = details.quantity
            item.price = details.price
            item.cost_price = details.cost_price
            item.totalStock = details.stock
            item.unit = details.unit
        })
    }

    @writer async updateCartCustomer(customer) {
        await this.update((cart) => {
            cart.customer.set(customer);
        });
    }
}